import React, { useEffect, useState, useContext } from "react";
import useProfileDashboard from "../../../services/Settings/useProfileDashboard";
import { usePosOrderSettings } from "../../../services/Pos/usePosOrderSettings";
import { GlobalContext } from "../../../Context/GlobalContext";

const ReceiptPrintingTab = ({ onLoadingChange }) => {
  const { fetchReceiptDetails } = useProfileDashboard();
  const { updatePrintSettings } = usePosOrderSettings();
  const { userID } = useContext(GlobalContext);

  const [settings, setSettings] = useState({});

  const [form, setForm] = useState({
    normalFontSize: "",
    largeFontSize: "",
    pageWidth: "",
    anlookActive: "0",
    autoPrint: "0",
  });

  const loadData = async () => {
     onLoadingChange?.(true); 
    const res = await fetchReceiptDetails();

    if (res?.response?.length) {
      const data = res.response[0];

      let config = data.printConfiguration;

      if (!config && data.printSettings) {
        config =
          typeof data.printSettings === "string"
            ? JSON.parse(data.printSettings)
            : data.printSettings;
      }

      const obj = {};
      config?.forEach((item) => {
        obj[item.key] = item.value;
      });

      setSettings(obj);

      setForm({
        normalFontSize: obj.normalFontSize || "",
        largeFontSize: obj.largeFontSize || "",
        pageWidth: obj.pageWidth || "",
        anlookActive: obj.anlookActive || "0",
        autoPrint: obj.autoPrint || "0",
      });
    }
     onLoadingChange?.(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const buildPayload = () => {
    return {
      userid: userID,
      printConfig: [
        { key: "normalFontSize", value: form.normalFontSize },
        { key: "largeFontSize", value: form.largeFontSize },
        { key: "pageWidth", value: form.pageWidth },
        { key: "anlookActive", value: form.anlookActive },
        { key: "autoPrint", value: form.autoPrint },
      ],
    };
  };

  //  SAVE HANDLER
  const handleSave = async () => {
     onLoadingChange?.(true);
    const payload = buildPayload();

    const res = await updatePrintSettings(payload);

    if (res) {
      await loadData();
    }
     onLoadingChange?.(false);
  };

  return (
    <>

    <div className="space-y-6 montserrat-font-1">
      {/*  TOP SECTION */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 montserrat-font-1">
        {/* LEFT → Current Settings */}
        <div className="bg-white border rounded-xl p-6 shadow-sm">
          <h2 className="text-green-600 font-semibold text-lg mb-4">
            Print Settings
          </h2>

          <div className="border-t pt-4 space-y-3 text-sm montserrat-font-1">
            <div className="flex justify-between">
              <span className="text-gray-600">
                Use Anlook Printing Software:
              </span>
              <span className="font-medium text-gray-800">
                {settings.anlookActive === "1" ? "Enabled" : "Disabled"}
              </span>
            </div>

            <div className="flex justify-between montserrat-font-1">
              <span className="text-gray-600">Auto-Print Receipts:</span>
              <span className="font-medium text-gray-800">
                {settings.autoPrint === "1" ? "Enabled" : "Disabled"}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-600">Receipt Print Mode:</span>
              <span className="font-medium text-gray-800">
                Print automatically after payment
              </span>
            </div>
          </div>

          <div className="border-t my-4"></div>

          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">normalFontSize:</span>
              <span>{settings.normalFontSize || "-"}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-600">largeFontSize:</span>
              <span>{settings.largeFontSize || "-"}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-600">pageWidth:</span>
              <span>{settings.pageWidth || "-"}</span>
            </div>
          </div>
        </div>

        {/* RIGHT → Update Form */}
        <div className="bg-white border rounded-xl p-5 shadow-sm montserrat-font-1">
          <h2 className="text-green-600 font-semibold mb-4">
            Update Printing Setting
          </h2>

          <div className="space-y-4">
            <input
              type="text"
              value={form.normalFontSize}
              onChange={(e) =>
                setForm({ ...form, normalFontSize: e.target.value })
              }
              placeholder="Normal Font Size"
              className="w-full border rounded-md px-3 py-2 text-sm"
            />

            <input
              type="text"
              value={form.largeFontSize}
              onChange={(e) =>
                setForm({ ...form, largeFontSize: e.target.value })
              }
              placeholder="Large Font Size"
              className="w-full border rounded-md px-3 py-2 text-sm"
            />

            <input
              type="text"
              value={form.pageWidth}
              onChange={(e) => setForm({ ...form, pageWidth: e.target.value })}
              placeholder="Page Width"
              className="w-full border rounded-md px-3 py-2 text-sm"
            />

            {/* Toggle */}
            <label className="flex items-center justify-between cursor-pointer montserrat-font-1">
              <span className="text-sm text-gray-600">
                Activate Anlook Printing Software
              </span>

              <div className="relative">
                <input
                  type="checkbox"
                  checked={form.anlookActive === "1"}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      anlookActive: e.target.checked ? "1" : "0",
                    })
                  }
                  className="sr-only peer"
                />

                <div className="w-11 h-6 bg-gray-300 rounded-full peer-checked:bg-green-600 transition"></div>

                <div
                  className="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full montserrat-font-1 shadow
      transition peer-checked:translate-x-5"
                ></div>
              </div>
            </label>

            <label className="flex items-center justify-between cursor-pointer">
              <span className="text-sm text-gray-600">
                Enable Auto Printing
              </span>

              <div className="relative">
                <input
                  type="checkbox"
                  checked={form.autoPrint === "1"}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      autoPrint: e.target.checked ? "1" : "0",
                    })
                  }
                  className="sr-only peer"
                />

                <div className="w-11 h-6 bg-gray-300 rounded-full montserrat-font-1 peer-checked:bg-green-600 transition"></div>

                <div
                  className="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow
      transition peer-checked:translate-x-5"
                ></div>
              </div>
            </label>

            <button
              onClick={handleSave}
              className="bg-green-600 text-white px-4 py-2 rounded-md"
            >
              Save
            </button>
          </div>
        </div>
      </div>

      {/*  BOTTOM SECTION */}
      {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border rounded-xl p-5 shadow-sm flex items-center justify-between">
          <div className="font-medium">Anlook Auto Printing Software</div>

          <button className="bg-green-600 text-white px-4 py-2 rounded-md">
            Download Now
          </button>
        </div>

        <div className="bg-white border rounded-xl p-5 shadow-sm">
          <h2 className="text-blue-600 font-semibold text-center mb-4">
            Step-by-Step Installation Guide
          </h2>

          <ol className="text-sm space-y-3 list-decimal pl-5">
            <li>
              <strong>Download the Software:</strong> Click Download
            </li>
            <li>Extract ZIP file</li>
            <li>Run AnlookAutoPrint.exe</li>
            <li>Set Auto Start</li>
            <li>Done</li>
          </ol>
        </div>
      </div> */}
    </div>
    </>
  );
};

export default ReceiptPrintingTab;
